module.exports = __webpack_public_path__ + "img/invoice-pdf.5631aff6.png";